import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { ProfileActionEnum } from '.';
import {
    IProfile,
    ProfileEnum,
} from '../../services';
import { FetchProfileFailedAction, FetchProfileSuccessAction } from './ActionCreator';
import { ProfileService } from '../../services/Profile.service';

const profileService = new ProfileService();

export const fetchProfileEpic = (action$: any) =>
  action$.pipe(
    ofType(ProfileActionEnum.FetchProfile),
    switchMap(() => {
      return profileService.getProfile().pipe(
        map((response: IProfile) => FetchProfileSuccessAction(response)),
        catchError((x) => {
          console.error(x);
          return of(FetchProfileFailedAction(ProfileEnum.UnableToFetchProfile));
        })
      );
    })
  );



